import type { FeatureFlagEvaluated, FeatureFlagType } from 'common/models';
import { useGetFeatureFlagsQuery } from 'common/queries';
import { useEffect, useState } from 'react';

/** Missing or not-yet-loaded flags keep the original top navigation available. */
export const useIsLeftMenuSidebarEnabled = () => {
  const { data } = useGetFeatureFlagsQuery();
  return isFeatureFlagEnabled('left_menu_sidebar', data?.featureFlags || []);
};

export const isFeatureFlagEnabled = (type: FeatureFlagType, flags: FeatureFlagEvaluated[]) => {
  return !!flags.find((x) => x.name === type && x.isEnabled);
};

// Service Object Count field feature flag checker
export const useIsServiceObjectCountEnabled = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  const data = useGetFeatureFlagsQuery().data;

  useEffect(() => {
    data && setIsEnabled(isFeatureFlagEnabled('serviceObject_count', data.featureFlags));
  }, [data]);

  return isEnabled;
};

// Multi language feature flag checker
export const useIsMultiLanguageEnabled = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  const data = useGetFeatureFlagsQuery().data;

  useEffect(() => {
    data && setIsEnabled(isFeatureFlagEnabled('multi_language', data.featureFlags));
  }, [data]);

  return isEnabled;
};

// PDF reports feature flag checker
export const useIsPDFReportsEnabled = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  const data = useGetFeatureFlagsQuery().data;

  useEffect(() => {
    data && setIsEnabled(isFeatureFlagEnabled('pdf_reports', data.featureFlags));
  }, [data]);

  return isEnabled;
};

// Mapy.com search provider feature flag checker
export const useIsMapyComSearchProviderEnabled = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  const data = useGetFeatureFlagsQuery().data;

  useEffect(() => {
    data && setIsEnabled(isFeatureFlagEnabled('mapycom_search_provider', data.featureFlags));
  }, [data]);

  return isEnabled;
};

// Payment type codebook feature flag checker
export const useIsPaymentTypeCodebookEnabled = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  const data = useGetFeatureFlagsQuery().data;

  useEffect(() => {
    data && setIsEnabled(isFeatureFlagEnabled('paymentType_codebook', data.featureFlags));
  }, [data]);

  return isEnabled;
};

// Service Object Timeline Summary feature flag checker
export const useIsServiceObjectTimelineSummaryEnabled = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  const data = useGetFeatureFlagsQuery().data;

  useEffect(() => {
    data && setIsEnabled(isFeatureFlagEnabled('serviceObject_timelineSummary', data.featureFlags));
  }, [data]);

  return isEnabled;
};

// Table showing Custom Forms, behind feature flag until we got all columns that we need to support
export const useIsCustomFormsTableEnabled = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  const data = useGetFeatureFlagsQuery().data;

  useEffect(() => {
    data && setIsEnabled(isFeatureFlagEnabled('custom_forms_table', data.featureFlags));
  }, [data]);

  return isEnabled;
};

// Import & export settings tab, hidden behind a feature flag (default off until rolled out)
export const useIsImportExportEnabled = () => {
  const [isEnabled, setIsEnabled] = useState(false);

  const data = useGetFeatureFlagsQuery().data;

  useEffect(() => {
    data && setIsEnabled(isFeatureFlagEnabled('import_export', data.featureFlags));
  }, [data]);

  return isEnabled;
};
